<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist
			@help="help"
			@add="add"
			@search="search"
			@reflash="reflash"
			@del="batchDel"
			@exps="exp"
			ref="SetBtn"
		></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
			ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Code" :label="$t('getapi[1832]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="empName" :label="$t('getapi[3201]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ITEM_CODE" :label="$t('getapi[876]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ITEM_NAME" :label="$t('getapi[546]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="CLIENT_CODE" :label="$t('getapi[2692]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remarks" :label="$t('getapi[143]')" width="100"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
						:confirmButtonText="$t('getapi[656]')"
						:cancelButtonText="$t('getapi[6]')"
						icon="el-icon-info"
						iconColor="red"
						:title="$t('getapi[637]')"
						@onConfirm="del(scope)"
					>
						<el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="32%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[1832]')}}</td>
					<td>
						<routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
						<el-input
							v-model="dataList.Code"
							:placeholder="$t('getapi[1832]')"
							readonly
						>
							<i  class="el-icon-edit el-input__icon" slot="suffix" @click="empmode()"></i>
						</el-input>
						</routejump>
					</td>
					<td>{{$t('getapi[3201]')}}</td>
					<td><el-input v-model="dataList.empName" type="text" size="mini" ></el-input></td>
               
                </tr>
				<tr>
					<td>{{$t('getapi[876]')}}</td>
					<td>
						<routejump :urlNo="5" :isDialog="1" @callback="beforeRoutJump">
						<el-input
							v-model="dataList.ITEM_CODE"
							:placeholder="$t('getapi[876]')"
							readonly
						>
							<i  class="el-icon-edit el-input__icon" slot="suffix" @click="itemmode()"></i>
						</el-input>
						</routejump>
					</td>
					<td>{{$t('getapi[546]')}}</td>
					<td><el-input v-model="dataList.ITEM_NAME" type="text" size="mini" ></el-input></td>
					
                </tr>
				<tr>
                    <td>{{$t('getapi[2692]')}}</td>
					<td><el-input v-model="dataList.CLIENT_CODE" type="text" size="mini" ></el-input></td>
                    <td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="dataList.remarks" type="text" size="mini" ></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<serce :isVisible="isVisible" queryData="SALPriceInfoRightViewInfo" ref="ser" @getser="serclick"></serce>
		<!-- 项目弹框 -->
		<itemCode :isVisible="false" @getproject="getitem" ref="initme"></itemCode>
		<!-- 人员弹框 -->
		<employee :isVisible="false" @getemployee="getemployee" ref="input"></employee>
	</div>
</template>

<script>
import Common from '@/components/Common';

export default {
	name:'employeesal',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			isVisible: false,
			DbTbNames: '', //表名
			userData: [],
			user: '',
			dataSet: [],
			dataList: {},
			oldDataList:[],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('employeesal'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			queryData: [], // 查询数组
			selectIDData: [],
			ids: '',
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.user = that.userData.username;
		that.getView();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1117]"),this.$t("getapi[11]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.ReadOnlyRights('plv2', 97, 1)) {
				that.$refs.SetBtn.SetButtonEnable('refresh');
			}
			//操作权
			let ilimits = that.$limits.UnOperationAuthority('plv2', 97, 1);
			// limits说明：、2 编辑权限、3 删除权限
			switch (ilimits) {
				case 2:
					that.btn.edit = true;
					that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh');
					break;
				case 3:
					that.btn.edit = true;
					that.btn.del = true;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,del');
					break;
				default:
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
			}
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('employeesal',val)
			this.intidata();
			this.authority();
		},
		// 查询
		search() {
			this.$refs.ser.clearInput(true, 'SALPriceInfoRightViewInfo');
		},
		//获取查询条件
		serclick(val) {
			console.log(val);
			this.queryData = val;
			this.PageIndex = 1;
			this.getView();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
			that.isVisible = true;
			that.dataList = row;
            that.oldDataList = JSON.stringify(that.dataList)
		},
		// 获取数据
		getView() {
			let that = this;
			that.loading = true;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: []
			};
			that.queryData.forEach(item => {
//				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
//				}
			});
			console.log(JSON.stringify(parm));
			that.$http.urlpost('/Basic/Sale/GetEmployeeItemList', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},
		// 保存数据
		save() {
			let that = this;
			that.loading = true;
			let parm = new Array();
			let parms = {
				_exclusively_id: that.dataList.Exclusively_Id,
				_employee_id: that.dataList.Employee_id,
				_item_id: that.dataList.Item_id,
				_remarks: that.dataList.remarks,
			};
			parm.push(parms);
			console.log(JSON.stringify(parm));
			that.$http.urlpost('/Basic/Sale/SaveEmployeeItem', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[284]'));
                    that.isVisible = false;
					that.getView();
				}
				that.loading = false;
			});
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
		},
		// 删除
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('/Basic/Sale/DeleteEmployeeItemByID', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[659]'));
					that.getView();
				}
			});
		},
		// 删除
		del(row) {
			console.log(row);
			this.ids = row.row.Exclusively_Id + ',';
			this.delf();
		},
		//批量删除
		batchDel() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
			let that = this;
			that.isVisible = true;
			that.dataList = {
				Exclusively_Id: 0,
				Code: '',
				empName: '',
				ITEM_CODE: '',
				ITEM_NAME: '',
				CLIENT_CODE: '',
				remarks: '',
				Employee_id: '',
				Item_id: '',
				_remarks: ''
			};
		},
		//导出·
		exp() {
			let that = this;
			that.loading = true;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: []
			};
			that.queryData.forEach(item => {
//				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
//				}
			});
			console.log(JSON.stringify(parm));
			that.$http.urlpost('/Basic/Sale/ExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
		// 刷新
		reflash() {
			this.getView();
		},
		//人员选择
		empmode() {
			this.$refs.input.clearInput(true,false,7);
		},
		// 项目选择
		itemmode() {
			this.$refs.initme.clearInput(true,false,2);
		},
		getitem(e){
			console.log(e);
			this.dataList.ITEM_CODE = e.item_code;
			this.dataList.ITEM_NAME = e.item_name;
			this.dataList.Item_id = e.exclusively_id;
			this.dataList.CLIENT_CODE = e.client_code;
		},
		getemployee(e){
			this.dataList.empName=e.name;
			this.dataList.Employee_id = e.num;
			this.dataList.Code = e.code;
		},
        beforeRoutJump(val,callback){
            let that = this
            if(that.oldDataList != JSON.stringify(that.dataList)){
                this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.isVisible = false
                        callback(true)
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            } else {
                that.isVisible = false
                callback(true)
            }
        },
	}
};
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
